import React, { ButtonHTMLAttributes } from 'react';
import styles from './Button.module.css';
import Icon from '../Icon/Icon';

type ButtonVariant = 'primary' | 'secondary' | 'outline' | 'ghost' | 'danger' | 'link';
type ButtonSize = 'xs' | 'small' | 'medium' | 'large' | 'app';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  fullWidth?: boolean;
  icon?: string;
  iconRight?: string;
  iconSize?: number;
}

const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'large',
  fullWidth = false,
  icon,
  iconRight,
  iconSize,
  className = '',
  children,
  ...rest
}) => {
  const defaultIconSize = size === 'xs' ? 14 : size === 'small' ? 16 : 18;
  const resolvedIconSize = iconSize ?? defaultIconSize;

  const classes = [
    styles.button,
    styles[variant],
    styles[size],
    fullWidth ? styles.fullWidth : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button className={classes} {...rest}>
      {icon && <Icon name={icon} size={resolvedIconSize} />}
      {children}
      {iconRight && <Icon name={iconRight} size={resolvedIconSize} />}
    </button>
  );
};

export default Button;
